export default function isEmail(value: string): boolean {
  return value.includes("@");
}
